<template>
  <div class="getCouponCenterDetail">
    <div class="base-info">
      <el-row class="row-info">
        <el-col :span="2" class="col-label">活动名称</el-col>
        <el-col :span="22" class="col-value">{{ form.name }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">活动时间</el-col>
        <el-col :span="22" class="col-value">
          {{ form.startTime ? $moment(form.startTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
          {{ form.endTime ? ' - ' + $moment(form.endTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">是否按时间段售卖</el-col>
        <el-col :span="22" class="col-value">
          <span style="margin-right: 40px;">{{ form.preheat == '1' ? '是' : '否' }}</span>
          <span v-if="form.preheat == '1'">{{ form.salesTime_show[0] + '~' + form.salesTime_show[1] }}</span>
        </el-col>
      </el-row>
        <el-row class="row-info">
        <el-col :span="2" class="col-label">售券场景</el-col>
        <el-col :span="22" class="col-value">{{ form.zoneName }}</el-col>
      </el-row>
       <el-row class="row-info">
        <el-col :span="2" class="col-label">商品ID</el-col>
        <el-col :span="22" class="col-value">{{ form.skuId }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">券渠道</el-col>
        <el-col :span="22" class="col-value">{{ channelTypeObj[form.channel] }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">券类型</el-col>
        <el-col :span="22" class="col-value">{{ couponTypeObj[form.couponKind] }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">{{ couponTypeObj[form.couponKind] }}</el-col>
        <el-col :span="22" class="col-value">
          <div class="coupon-table" style="margin-left: 0;">
            <coupon-table :tableTrData="tableTrData" :couponType="couponType"></coupon-table>
          </div>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">售价</el-col>
        <el-col :span="22" class="col-value">
          <span>{{ form.price }}元</span>
          <span v-if="form.point">+{{ form.point }}积分</span>
        </el-col>
      </el-row>
      <el-row class="row-info" v-if="form.channel == 'VoucherCenter' && form.appendSkuRecord && form.appendSkuRecord.length != 0">
        <el-col :span="2" class="col-label">追加记录</el-col>
        <el-col :span="22" class="col-value">
          <div class="coupon-table" style="margin-left: 0;">
            <Table
              :tableThData="voucherCenter_tableThData"
              :tableTrData="form.appendSkuRecord"
              :pagination="false"
            >
              <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---'}}</template>
              <template #sort="{ row }">{{ row.sort }}</template>
              <template #amount="{ row }">{{ row.amount }}</template>
            </Table>
          </div>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">售卖数量</el-col>
        <el-col :span="22" class="col-value">{{ form.amount }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">是否隐藏券</el-col>
        <el-col :span="22" class="col-value">{{ form.hidden ? '是' : '否' }}</el-col>
      </el-row>
      <el-row class="row-info" v-if="!form.hidden">
        <el-col :span="2" class="col-label">是否同步首页</el-col>
        <el-col :span="22" class="col-value">{{ form.deliveryChannel=='First'?'是':'否' }}</el-col>
      </el-row>
      <el-row class="row-info" v-if="!form.hidden && form.deliveryChannel">
        <el-col :span="2" class="col-label">渠道序号</el-col>
        <el-col :span="22" class="col-value">{{ form.sort?form.sort:'---'}}</el-col>
      </el-row>
      <el-row class="row-info" v-if="!form.hidden">
        <el-col :span="2" class="col-label">活动序号</el-col>
        <el-col :span="22" class="col-value">{{ form.sorted}}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">券每天总卖限制</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.dailyTotal === '1'">无限制</span>
          <span v-else>每天总限卖{{ form.dailyTotalLimit }}张</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">每日限买次数</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.userDaily === '1'">无限制</span>
          <span v-else>每天总限买{{ form.userDailyLimit }}张</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">用户总买限制</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.userTotal === '1'">无限制</span>
          <span v-else>用户总限买{{ form.userTotalLimit }}张</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">发放用户</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.useRange == 'AllUser'">所有用户</span>
          <span v-if="form.useRange == 'SpecifyUser'">指定画像</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">过期自动退款</el-col>
        <el-col :span="22" class="col-value">{{ form.refundable ? '允许自动退款' : '不允许自动退款' }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">范围类型</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.scopeType == 'AllMall'">所有商场</span>
          <div v-if="form.scopeType == 'Mall'">
            <span v-for="item in filterMallData" :key="item.id">{{ item.name }}，</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import couponTable from '../../components/couponTable.vue'
import Table from "@/components/Table/index";

export default {
  name: "getCouponCenterDetail",
  components: {
    Table,
    couponTable
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tableTrData: {
      type: Array,
      default: () => []
    },
    filterMallData: {
      type: Array,
      default: () => []
    },
    couponType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      couponTypeObj: {
        'Coupon': '优惠券',
        'WelfareCoupon': '福利券',//券中台福利券
        'Recharge': '直充商品',//券中台直充商品
        'GiftCoupon': '礼品券',
        'LotCoupon': '停车券',
        'DeductCoupon': '抵扣券'

      },
      channelTypeObj: {
        'RT': '闰土自制',
        'VoucherCenter': '券中台投放',
      },
      voucherCenter_tableThData:[
        { prop: "updated", label: "追加时间", minWidth: "200", },
        { prop: "sort", label: "追加次数", minWidth: "90", },
        { prop: "amount", label: "追加数量", minWidth: "120", },
      ],//券中台追加记录列表
    };
  },
  created() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.getCouponCenterDetail {
  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }
}
</style>
